import newConversationImage from 'Assets/icons/user-conversation.svg';
import React from 'react';

export const NewConversationPlaceholder = () => {
  return (
    <div className="group flex items-center h-[56px] px-[10px] border-l-[3px] bg-muted border-primary">
      <div className="flex items-center justify-center w-[30px] h-[30px] rounded-full bg-foreground text-white">
        <img src={newConversationImage} alt="new conversation" />
      </div>
      <div className="ml-3.5 text-base text-foreground font-bold">
        New conversation
      </div>
    </div>
  );
};
